<template>
  <div>
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">Invoices</h3>
            <p class="text-sm mb-0">Invoices, payments and debts</p>
          </template>
          <div class="row card-body">
            <div class="col-lg-2">
              <base-input label="Start date">
                <flat-picker
                  class="form-control datepicker"
                  :config="{ allowInput: true }"
                  v-model="filter.start"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-2">
              <base-input label="End date">
                <flat-picker
                  :config="{ allowInput: true, minDate: filter.start }"
                  class="form-control datepicker"
                  v-model="filter.end"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-8">
              <!-- <base-input label="Criteria"> </base-input> -->
              <label>Criteria</label>
              <table>
                <tr>
                  <td valign="top">
                    <el-select
                      class="select-primary pagination-select"
                      v-model="filter.searchtype"
                      placeholder="Select"
                      @change="
                        filter.respperson = '';
                        filter.code = '';
                      "
                    >
                      <el-option
                        class="select-primary"
                        :key="1"
                        label="Teacher"
                        :value="1"
                      ></el-option>
                      <el-option
                        class="select-primary"
                        :key="2"
                        label="Class code"
                        :value="2"
                      ></el-option>
                    </el-select>
                  </td>
                  <td valign="top" width="200px">
                    <el-select
                      v-if="filter.searchtype === 1"
                      class="select-primary pagination-select"
                      v-model="filter.respperson"
                      placeholder="Teacher"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in teachers"
                        :key="item.id"
                        :label="item.fullname"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <base-input
                      v-if="filter.searchtype === 2"
                      name="code"
                      type="success"
                      v-model="filter.code"
                      placeholder="Code"
                    ></base-input>
                  </td>
                  <td valign="top">
                    <base-button type="primary" @click.prevent="onGo"
                      >Go</base-button
                    >
                  </td>
                </tr>
              </table>
            </div>
            <div class="col-lg-12">
              <base-button type="primary" @click.prevent="onNew">
                <span class="btn-inner--icon">
                  <i class="ni e-add"></i> </span
                >New invoice
              </base-button>
              <base-button type="info" @click.prevent="onRefresh" icon>
                <span class="btn-inner--icon">
                  <i class="ni refresh-02"></i> </span
                >Refresh
              </base-button>
              <el-table
                :border="true"
                :data="tableData"
                row-key="id"
                header-row-class-name="thead-light"
                show-summary
                :summary-method="getSummaries"
              >
                <el-table-column
                  prop="code"
                  label="Class code"
                  width="120px"
                ></el-table-column>
                <el-table-column label="Course" width="200px">
                  <div slot-scope="{ row }">
                    {{ row.coursecode }}.{{ row.coursetitle }}
                  </div>
                </el-table-column>
                <el-table-column
                  prop="startdate"
                  label="start date"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="enddate"
                  label="end date"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="payertypename"
                  label="Payer type"
                  width="150px"
                ></el-table-column>
                <el-table-column
                  prop="payername"
                  label="Payer"
                  width="200px"
                ></el-table-column>
                <el-table-column
                  prop="amount"
                  label="Amount"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="studentcount"
                  label="students"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="inittotalamount"
                  label="init Total"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="restotalamount"
                  label="Total"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="paidsum"
                  label="Paid"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="debt"
                  label="Debt"
                  width="120px"
                ></el-table-column>
                <el-table-column label="Installment" width="135px">
                  <div slot-scope="{ row }">
                    <span
                      :class="{
                        'text-danger': row.installmentvalid === 0,
                        'text-success': row.installmentvalid === 1,
                      }"
                      >{{ row.installmentvalid === 1 ? "ok" : "wrong" }}</span
                    >
                  </div>
                </el-table-column>
                <!-- <el-table-column>
                  <div slot-scope="{row}">code
                    <div class="row">
                      <div class="col-lg-2">
                        <h5 class="mb-10">Class code</h5>
                      </div>
                      <div class="col-lg-2">{{row.code}}</div>
                      <div class="col-lg-2">
                        <h5 class="mb-10">Course</h5>
                      </div>
                      <div class="col-lg-6">{{row.coursecode}}.{{row.coursetitle}}</div>

                      <div class="col-lg-2">
                        <h5 class="mb-0">Amount</h5>
                      </div>
                      <div class="col-lg-2">{{row.amount}}</div>
                      <div class="col-lg-2">
                        <h5 class="mb-0">Start date</h5>
                      </div>
                      <div class="col-lg-2">{{row.startdate}}</div>
                      <div class="col-lg-2">
                        <h5 class="mb-0">End date</h5>
                      </div>
                      <div class="col-lg-2">{{row.enddate}}</div>

                      <div class="col-lg-2">
                        <h5 class="mb-0">Payer type</h5>
                      </div>
                      <div class="col-lg-2">{{row.payertypename}}</div>
                      <div class="col-lg-2" v-if="row.payertype === 2">
                        <h5 class="mb-0">Payer</h5>
                      </div>
                      <div class="col-lg-6" v-if="row.payertype === 2">{{row.payername}}, {{row.payerphone}}</div>
                    </div>
                  </div>
                </el-table-column>-->
                <el-table-column
                  width="150px"
                  align="center"
                  label="Actions"
                  fixed="right"
                >
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <base-button
                      @click.native="onEdit($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      <i class="text-white ni n-edit"></i>
                    </base-button>
                    <base-button
                      @click.native="onDelete($index, row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="text-white ni e-remove"></i>
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetPayments, DeletePayment } from "../../../services/payments";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { GetTeachers } from "../../../services/user";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    flatPicker,
  },
  data() {
    return {
      teachers: [],
      tableData: [],
      filter: {
        start: new Date(),
        end: new Date(),
        code: "",
        respperson: "",
        searchtype: 1,
      },
      isLoading: false,
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sum";
          return;
        }
        if (index < 8 || index > 11) return;
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] =
            "₼ " +
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    onRefresh() {
      this.onGo();
    },
    onNew() {
      this.$router
        .push({ path: "/manager/payment", params: { id: "" } })
        .catch((e) => {});
    },
    onEdit(index, row) {
      this.$router
        .push({ path: "/manager/payment/" + row.id })
        .catch((e) => {});
    },
    onGo() {
      this.isLoading = true;
      GetPayments(this.filter).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            DeletePayment(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.onGo();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
  },
  mounted() {
    this.filter.start = new Date(this.filter.start).setDate(
      new Date(this.filter.start).getDate() - 90
    );
    this.filter.end = new Date();
    GetTeachers().then((response) => {
      if (response.data !== null) {
        this.teachers = response.data.result;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
</style>